import React from 'react';
import {
  RadioInputStyles,
  RadioInputTemplateProps,
  ToolTipElement,
} from '../../..';

export const RadioInputPaymentTemplate = (props: RadioInputTemplateProps) => {
  return (
    <RadioInputStyles className={props.classes}>
      <label className="radio-label">
        <input
          className="radio-input"
          id={props.id}
          type="radio"
          name={props.name}
          checked={props.checked}
          value={props.checked ? 'on' : 'off'}
          disabled={props.disabled}
          onClick={(e) => {
            if (!props.checked) {
              props.onClick(e);
            }
          }}
          onChange={() => ({})}
          data-clean={props['data-clean']}
          data-blurred={props['data-blurred']}
          data-valid={props['data-valid']}
        />
        <span className="radio-input-inlay">{props.inlay}</span>
        <span className="radio-layout">
          {props.checked && <span className="radio-inner-layout" />}
        </span>
        {props.tips && props.tips.length ? (
          <ToolTipElement styleClasses={['toolTipBase']} tips={props.tips} />
        ) : (
          ''
        )}
      </label>
    </RadioInputStyles>
  );
};
